import { PortProtocol } from '@/consts/machine'

export interface PresetPort {
  srcPort: number | string
  protocol: number
}

function isSupportedPortProtocol(protocol: number | undefined): protocol is PortProtocol {
  return (
    protocol === PortProtocol.SSH ||
    protocol === PortProtocol.HTTP ||
    protocol === PortProtocol.VNC ||
    protocol === PortProtocol.RDP
  )
}

export function resolveMappedPortProtocol(
  srcPort: number,
  presetPorts: PresetPort[],
): PortProtocol {
  const presetProtocol = presetPorts.find((port) => Number(port.srcPort) === srcPort)?.protocol

  return isSupportedPortProtocol(presetProtocol) ? presetProtocol : PortProtocol.SSH
}
